<script>
export default {
  props: {
    score: Number,
    maxCount: Number
  },
  data() {
    let starList = [];
    let starCounts = this.maxCount || 3;
    for (let j = 0; j < starCounts; j++) {
      starList.push("el-icon-star-off blankStar");
    }
    let redStar = Math.floor(this.score / 2);
    let i = 0;
    for (; i < redStar; i++) {
      starList[i] = "el-icon-star-on redStar";
    }
    if (this.score % 2 !== 0) {
      starList[i] = "el-icon-star-on yellowStar";
    }
    return {
      starList
    };
  }
};
</script>

<template>
  <div>
    <i v-for="(item, index) in starList" :key="item + index" :class="item" />
  </div>
</template>

<style lang="scss" scoped>
.redStar {
  color: #f55656;
  font-size: 16px;
}
.yellowStar {
  color: #ffbc0b;
  font-size: 16px;
}
.blankStar {
  color: #e1e1e1;
  font-size: 15px;
}
</style>





// WEBPACK FOOTER //
// yotta-vue-components/vision/gameRateStar.vue